import { Box, HStack, Text, Icon, useDisclosure, Divider, StackDivider } from '@chakra-ui/react';

import { IoTimeOutline } from 'react-icons/io5';

import ContentContainer from '~/containers/Content';

type FilterInfoBarProps = {
  pickTimeString: string;
  store?: string;
  tag?: string;
};

export default function FilterInfoBar({ pickTimeString, store, tag }: FilterInfoBarProps) {
  return (
    <Box>
      <ContentContainer>
        <HStack px={4} py={2} borderBottomColor="primary" borderBottomWidth="1px">
          <Icon as={IoTimeOutline} color="primary" boxSize="1.5rem" />
          <Text flex="1" fontWeight="bold">
            {pickTimeString}
          </Text>
        </HStack>
        {!!store || !!tag ? (
          <HStack justify="left" px={4} py={2} spacing={4}>
            <Text flex="1" fontWeight="bold">
              {store}
            </Text>
            <StackDivider orientation="vertical" h={6} w="1px" bgColor="primary" />

            <Text flex="1" fontWeight="bold">
              {tag}
            </Text>
          </HStack>
        ) : null}
      </ContentContainer>
    </Box>
  );
}
